import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { setEmail } from '../features/chatSlice';

function EmailPrompt({ show, onClose }) {
  const dispatch = useDispatch();
  const [emailInput, setEmailInput] = useState('');

  const handleContinue = () => {
    dispatch(setEmail(emailInput));
    onClose();
  };

  return (
    <Modal show={show} onHide={onClose} centered backdrop="static">
      <Modal.Header>
        <Modal.Title>Welcome!</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Want to enter your email before chatting?</p>
        <Form.Group>
          <Form.Label>Email (optional)</Form.Label>
          <Form.Control
            type="email"
            value={emailInput}
            onChange={(e) => setEmailInput(e.target.value)}
            placeholder="you@example.com"
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>Skip</Button>
        <Button variant="primary" onClick={handleContinue} disabled={!emailInput}>Continue</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default EmailPrompt;
